import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { DateTimeHelper, TimePeriodType } from '../../../../helper/date-time.helper';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import { UserTokenService } from '../../../../services/user-service/user-token.service';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { AppointmentsHelper } from '../../../../helper/appointments.helper';
import {
  LeadsMultipleStepByStepService
} from "../../../../services/leads-multiple-step-by-step/leads-multiple-step-by-step.service";
import { ActionHelper } from "../../../../helper/action.helper";

@Component({
  selector: 'fi-lead-reminder-popup',
  templateUrl: './lead-reminder-popup.component.html',
  styleUrls: ['./lead-reminder-popup.component.scss'],
  standalone: false,
})
export class LeadReminderPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  selectedTypeId: number;
  readonly dateOptionTypes = DateTimeHelper.datePeriodTypes;

  searchedText = '';
  note = '';
  selectedDate: Date;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_REMINDER', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_REMINDER', true);
  submitting: boolean;
  appointmentExists = false;
  dateHasChangedData: string;
  inValidNote = false;
  isMany: boolean;
  leads: number[];
  private cancel = false;
  step: number = 0;


  constructor(
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    private userTokenService: UserTokenService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<LeadReminderPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {contactName: string, leadId: number, leadTypeId: number, title: string, leads: number[], isMany: boolean},
    private leadsMultipleStepByStepService: LeadsMultipleStepByStepService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.isMany = dialogData?.isMany;
    this.leads = dialogData?.leads;

    leadsMultipleStepByStepService.listenToCancel().subscribe(data => {
      this.cancel = true;
    })

  }

  onDateSelect(date: Date, time = false): void {
    this.selectedTypeId = null;


    if (!date) {
      this.selectedDate = null;
      return;
    }

    if (!this.selectedDate) {
      this.selectedDate = date;
    } else if (!time) {
      this.selectedDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    } else {
      this.selectedDate.setHours(date.getHours(), date.getMinutes());
    }

    this.selectedDate = new Date(this.selectedDate);


    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  setPeriods($event): void {
    this.selectedTypeId = $event;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(this.dateOptionTypes.find(item => item.Id === +$event));
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  onDateOptionSelected(type: TimePeriodType): void {
    this.selectedTypeId = type.Id;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(type);
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  async ngOnInit(): Promise<void> {
    const userId = await this.userTokenService.getId();
    AppointmentsHelper.getDbAppointments(this.actionDataService, userId);
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    if (this.isMany) {
      return this.leads.length > 0 && !this.inValidNote && !this.submitting && !!this.selectedDate && !!this.note?.trim();
    }
    return !!this.leadId && !!this.selectedDate && !this.submitting && !this.inValidNote && !!this.note?.trim();
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submitStepByStep(): void {
    if (this.cancel) {
      return;
    }
    this.clearClassAndCloseDialog(this.dialogRef, 'remove');

    this.actionDataService.sendReminder(this.leads[this.step], this.note, this.selectedDate)
      .subscribe(({ success, data }) => {
        if (this.leads.length - 1 === this.leads.lastIndexOf(this.leads[this.step])) {
          this.submitting = false;
        }

        this.step++;
        this.leadsMultipleStepByStepService.switchToNextStep();

        if (this.leads[this.step]) {
          this.submitStepByStep();
        }
      });
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;

      if (this.isMany) {
        let action: any = { Name: 'MULTIPLE_LEADS_STEP_BY_STEP', Text: 'Bald geschafft...', leadsLength: this.leads.length, actionName: 'LEAD_REMINDER'}
        ActionHelper.doAction({} as any, action, this.dialog, this.leads, true)?.afterClosed().subscribe();
        this.submitStepByStep();
      } else {
        this.actionDataService.sendReminder(this.leadId, this.note, this.selectedDate)
          .subscribe(({ success, data }) => {
            if (success) {
              this.clearClassAndCloseDialog(this.dialogRef, 'remove');
            }
            this.submitting = false;
          });
      }
    }
  }
}
